export const DATE_FORMAT = "YYYY-MM-DD";
export const TIME_FORMAT = "hh:mm:ss";
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;

export const TIMESTAMP_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}.SSS`;
